import { useTasks } from 'app/agriculture/queries/tasks/useTasks';
import { useMemo } from 'react';
import { Task } from 'app/agriculture/queries/tasks/types/Task';

export function useTasksForEntity(id: string) {
    const tasks = useTasks();

    const tasksByParentId = useMemo(() => {
        const map = new Map<Task['parentIds'][number], Task[]>();
        for (const task of tasks.values()) {
            for (const parentId of task.parentIds) {
                map.set(parentId, [...(map.get(parentId) ?? []), task]);
            }
        }
        return map;
    }, [tasks]);

    return useMemo(() => tasksByParentId.get(id) ?? [], [tasksByParentId, id]);
}
